import React from "react";
import styled from "styled-components";
import { toShortMonthText } from "../../../utils/date";
import * as dateMath from 'date-arithmetic';
import { colors } from "../../colors/color";


type TimelineGraphMonthProps = {
    yearMonthStart: Date,
    rowWidthPx: number,
    months: number,
};
export function TimelineGraphMonthHeader (props: TimelineGraphMonthProps): JSX.Element
{
    const months = [];
    for (let i = 0; i < props.months; i++)
    {
        months.push(toShortMonthText(dateMath.add(props.yearMonthStart, i, 'month')));
    }

    return (
        <div>
            <HeaderWrapper>
                {months.map(m => <GraphMonthHeader key={m}>{m}</GraphMonthHeader>)}
            </HeaderWrapper>
        </div>
    );
}


const border = '0px solid #000';

const HeaderWrapper = styled.div`
    display:flex; 
    justify-content:stretch;
`;

const GraphMonthHeader = styled.div`
    border-left:${border};
    border-top:${border};
    border-bottom:${border};
    flex-grow: 1;
    display:flex;
    justify-content: center;
    line-height: 20px;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color:${colors.text.light};
    text-transform: uppercase;

    :last-child
    {
        border-right:${border};
    }
`;